import { TCutbankOutState } from './cutbank-out-db.models';
import { TCutbankOutActions } from './cutbank-out-db.actions';

export const cutbankOutStoreInitalState: TCutbankOutState = {
  subjects: [],
  transactionLogInfo: null,
  activityLogInfo: null,
  isComponentBundleScanEnabled: false,
};

export function cutbankOutStoreStateReducer(
  state: TCutbankOutState = cutbankOutStoreInitalState,
  action: TCutbankOutActions,
): TCutbankOutState {
  switch (action.type) {
    case 'GET_SUBJECT_LIST_CUTBANK_OUT_SUCCESS':
      return {
        ...state,
        subjects: action.cutbankOutRes,
      };

    case 'GET_TRANSACTION_LOG_CUTBANK_OUT_SUCCESS':
      return {
        ...state,
        transactionLogInfo: action.transactionLog,
      };
    case 'GET_ACTIVITY_LOG_CUTBANK_OUT_SUCCESS':
      return {
        ...state,
        activityLogInfo: action.activityLog,
      };
    case 'IS_COMPONENT_BUNDLE_SCAN_ENABLED_CUTBANK_OUT_SUCCESS':
      return {
        ...state,
        isComponentBundleScanEnabled: action.isComponentBundleScanEnabled,
      };
    default:
      return state;
  }
}
